import { render, staticRenderFns } from "./IconPoiEducation.vue?vue&type=template&id=1167d178&"
import script from "./IconPoiEducation.vue?vue&type=script&lang=js&"
export * from "./IconPoiEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports